<template>
  <!-- 修改密码、修改绑定手机号 -->
  <el-dialog
    class="dialog-modify-base"
    :append-to-body="true"
    :visible.sync="dialogVisible"
    :title="pageType === 'reset' ? '重置密码' : '修改手机号'"
    width="500px"
  >
    <!-- 重置密码 -->
    <el-form
      class="g-form-grid"
      :model="form"
      :rules="rules"
      ref="form"
      label-width="100px"
      v-if="pageType === 'reset'"
    >
      <!-- 处理input被填充的bug -->
      <div class="hide">
        <input type="text">
        <input type="password">
      </div>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="当前密码" prop="oldpass">
            <el-input
              type="password"
              v-model="form.oldpass"
              placeholder="请输入"
              readonly
              @focus="handleFocusEvent"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="新密码" prop="pass">
            <el-input type="password" v-model="form.pass" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="确认新密码" prop="checkPass">
            <el-input type="password" v-model="form.checkPass" placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <!-- 修改手机号 -->
    <el-form
      class="g-form-grid"
      :model="form2"
      :rules="rules2"
      ref="form"
      label-width="120px"
      v-if="pageType === 'phone' || pageType === 'sureModify'"
    >
      <!-- 当前手机号 -->
      <div v-if="pageType === 'phone'">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="当前手机号" key="mykey1">
              <span>{{$store.state.user.phone.substring(0,3)}}****{{$store.state.user.phone.substring(7)}}</span>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="16">
            <el-form-item label="验证码" prop="codeVetify" key="mykey2">
              <el-input v-model="form2.codeVetify" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-button type="primary" @click="sendMsg" v-if="!resetMsg">发送验证码</el-button>
            <el-button type="primary" :disabled="true" v-if="resetMsg">重新发送({{resetMsg}}s)</el-button>
          </el-col>
        </el-row>
      </div>

      <!-- 绑定新手机号 -->
      <div v-if="pageType === 'sureModify'">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="绑定新手机号" prop="newPhone" key="mykey3">
              <el-input v-model="form2.newPhone" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="16">
            <el-form-item label="验证码" prop="codeVetify2" key="mykey4">
              <el-input v-model="form2.codeVetify2" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-button type="primary" @click="sendMsg" v-if="!resetMsg">发送验证码</el-button>
            <el-button type="primary" :disabled="true" v-if="resetMsg">重新发送({{resetMsg}}s)</el-button>
          </el-col>
        </el-row>
      </div>
    </el-form>

    <div slot="footer" class="footer tc mt-30">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button
        @click="fromSubmit('form')"
        type="primary"
        :loading="loadingSave"
      >{{pageType === 'phone'?'下一步':'确定'}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { validate, setCookieEncrypt } from '@/utils/util'
export default {
  data() {
    let validatePhoneNo = (rule, value, callback) => {
      if (!validate(value, 'phone')) {
        callback(new Error('手机号不存在'))
      } else {
        callback()
      }
    }
    let validatePass = (rule, value, callback) => {
      if (!validate(value, 'password')) {
        callback(new Error('6-20位数字、字母、特殊字符至少包含两种'))
      } else {
        if (this.form.checkPass !== '') {
          this.$refs.form.validateField('checkPass')
        }
        callback()
      }
    }
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.form.pass) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      dialogVisible: false,
      loadingCode: false, // 正在发送验证码
      loadingSave: false,
      resetMsg: '',
      form: {
        oldpass: '',
        pass: '',
        checkPass: ''
      },
      form2: {
        codeVetify: '',
        newPhone: '',
        codeVetify2: ''
      },
      rules: {
        oldpass: [
          { required: true, message: '请输入当前密码', trigger: 'blur' }
        ],
        pass: [
          { required: true, message: '设置6至20位登录密码', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPass: [
          { required: true, message: '请再次输入登录密码', trigger: 'blur' },
          { validator: validatePass2, trigger: 'blur' }
        ]
      },
      rules2: {
        codeVetify: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        newPhone: [
          { required: true, message: '请输入新手机号', trigger: 'blur' },
          { validator: validatePhoneNo, trigger: 'blur' }
        ],
        codeVetify2: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      pageType: 'reset' //'reset' 重置密码 'phone' 修改手机 newPhone 确认修改手机
    }
  },
  methods: {
    init(pageType) {
      this.pageType = pageType

      // 重置
      this.form = {
        oldpass: '',
        pass: '',
        checkPass: ''
      }
      this.form2 = {
        codeVetify: '',
        newPhone: '',
        codeVetify2: ''
      }

      this.dialogVisible = true

      this.$nextTick(() => {
        this.$refs['form'].clearValidate() // 清空验证状态
      })
    },
    // 处理input被填充的bug
    handleFocusEvent(event) {
      event.target && event.target.removeAttribute('readonly')
    },
    // 发送验证码
    sendMsg() {
      this.loadingCode = true
      this.timeDown()
      this.$http
        .get('/login/front/sendChangePhoneCode', {
          phone:
            this.pageType === 'sureModify'
              ? this.form2.newPhone
              : this.$store.state.user.phone,
          step: this.pageType === 'sureModify' ? 1 : 0 // 0：原手机 1：新手机
        })
        .then(res => {
          this.loadingCode = false
          if (!res.success) {
            this.$message.error(res.message)
          }
        })
        .catch(() => {
          this.loadingCode = false
        })
    },
    // 倒计时
    timeDown() {
      this.resetMsg = 60
      let times = setInterval(() => {
        if (this.resetMsg <= 0) {
          this.resetMsg = ''
          clearInterval(times)
        } else {
          this.resetMsg--
        }
      }, 1000)
    },
    fromSubmit(form) {
      if (this.pageType === 'phone') {
        this.nextStep(form)
      } else if (this.pageType === 'sureModify') {
        this.modifyPhone(form)
      } else {
        this.resetPass(form)
      }
    },
    // 重置密码
    resetPass(form) {
      this.$refs[form].validate(vaild => {
        if (vaild) {
          this.loadingSave = true

          this.$http
            .post('/user/updatePassword', {
              pwd: this.form.oldpass,
              newpwd: this.form.pass,
              newpwd2: this.form.checkPass
            })
            .then(res => {
              this.loadingSave = false
              if (res.success) {
                this.$message.success('重置密码成功')
                this.dialogVisible = false
              } else {
                this.$message.error(res.message)
              }
            })
            .catch(() => {
              this.loadingSave = false
            })
        }
      })
    },
    // 下一部
    nextStep(form) {
      this.$refs[form].validate(vaild => {
        if (vaild) {
          // 验证验证码
          this.$http
            .get('/login/front/checkChangePhoneCode', {
              phone: this.$store.state.user.phone,
              step: 0, // 0：验证原手机 1：验证新手机
              verification: this.form2.codeVetify
            })
            .then(res => {
              this.loadingCode = false
              if (res.success) {
                this.resetMsg = 0
                this.pageType = 'sureModify'
              } else {
                this.$message.error(res.message)
              }
            })
            .catch(() => {
              this.loadingCode = false
            })
        }
      })
    },
    // 修改手机号
    modifyPhone(form) {
      this.$refs[form].validate(vaild => {
        if (vaild) {
          this.loadingSave = true

          this.$http
            .get('/login/front/checkChangePhoneCode', {
              phone: this.form2.newPhone,
              step: 1, // 0：验证原手机 1：验证新手机
              verification: this.form2.codeVetify2
            })
            .then(res => {
              this.loadingSave = false
              if (res.success) {
                this.$store.commit('SET_USER_PHONE', this.form2.newPhone)
                setCookieEncrypt('phone', this.form2.newPhone)
                this.$message.success('修改手机号成功')
                this.dialogVisible = false
              } else {
                this.$message.error(res.message)
              }
            })
            .catch(() => {
              this.loadingSave = false
            })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-modify-base {
}
</style>


